import { render } from "./Promo-templates.vue?vue&type=template&id=55ff30b1&scoped=true"
import script from "./Promo-templates.vue?vue&type=script&lang=js"
export * from "./Promo-templates.vue?vue&type=script&lang=js"

import "./Promo-templates.vue?vue&type=style&index=0&id=55ff30b1&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55ff30b1"]])

export default __exports__